import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AssetColor, AssetSize, Divider, DividerLine, Icon, IconName } from '@enbw/ui-react'
import styles from './styles.module.scss'
import { useAppStore } from '@/stores/useAppStore'

export const LanguageSwitcher: FC = () => {
  const { t } = useTranslation()
  const { language, setLanguage } = useAppStore()
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false)

  const handleEnglish = () => {
    setLanguage('en')
  }

  const handleGerman = () => {
    setLanguage('de')
  }

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen)
  }

  return (
    <div className={styles.languageSwitcher}>
      <button className={styles.menuItem} onClick={toggleSubMenu}>
        <Icon name={IconName.Language} size={AssetSize.XSmall} color={AssetColor.BrandPrimary} />
        <span className={styles.menuItemLabel}>{t('header.language')}</span>
        <Icon name={IconName.ChevronRight} size={AssetSize.XSmall} color={AssetColor.BrandPrimary} />
      </button>
      {isSubMenuOpen && (
        <div className={styles.subMenu}>
          <button className={styles.menuItem} onClick={handleGerman}>
            <span className={styles.menuItemLanguageLabel}>{t('languages.de')}</span>
            {language === 'de' && <Icon label={t('languages.deSelected')} name={IconName.Checkmark} size={AssetSize.XSmall} color={AssetColor.BrandPrimary} />}
          </button>
          <Divider line={DividerLine.Subtle} />
          <button className={styles.menuItem} onClick={handleEnglish}>
            <span className={styles.menuItemLanguageLabel}>{t('languages.en')}</span>
            {language === 'en' && <Icon label={t('languages.enSelected')} name={IconName.Checkmark} size={AssetSize.XSmall} color={AssetColor.BrandPrimary} />}
          </button>
        </div>
      )}
    </div>
  )
}
